import { ILink } from '../../../Types/ILink'

export const linkList: ILink[] = [
    {
        title: 'Contacts',
        path: '/contacts'
    }

]